import React from 'react';
import { colorPalette } from '../../colorPalette';
import { RakutenIcon } from '@rakutenfrance/material-ui-icons';
import Box from '@mui/material/Box';
export var Padding;
(function (Padding) {
    Padding["small"] = "2px 4px";
    Padding["medium"] = "4px 8px";
    Padding["large"] = "8px 10px";
})(Padding || (Padding = {}));
export const Label = (props) => {
    const { children, backgroundColor, hoverBackgroundColor = 'green200', textColor, icon, endIcon, iconSize, letterSpacing, fontSize, borderRadius, margin, padding = 'medium', border, textTransform, fontWeight, lineHeight, iconStyle, onClick, dataQa = 'label', width, gap, } = props;
    const labelStyle = {
        display: 'inline-flex',
        alignItems: 'center',
        fontWeight: fontWeight || 600,
        lineHeight: lineHeight || '15px',
        backgroundColor: backgroundColor ? colorPalette[backgroundColor] : colorPalette.white,
        color: textColor ? colorPalette[textColor] : colorPalette.white,
        letterSpacing: letterSpacing || '1px',
        fontSize: fontSize || '12px',
        borderRadius: borderRadius || '4px',
        margin: margin || 0,
        padding: padding && padding in Padding ? Padding[padding] : padding,
        border: border || 'none',
        textTransform: textTransform || 'uppercase',
        width: width || 'fit-content',
        gap: gap || '0px',
    };
    return (React.createElement(Box, { component: 'div', sx: [
            labelStyle,
            onClick
                ? Object.assign(Object.assign({}, labelStyle), { cursor: 'pointer', '&:hover': {
                        backgroundColor: hoverBackgroundColor,
                    } }) : labelStyle,
            {},
        ], "data-qa": dataQa, onClick: onClick },
        icon && (React.createElement(Box, { sx: { display: 'flex', justifyContent: 'center', marginRight: '4px' } }, typeof icon === 'string' ? React.createElement(RakutenIcon, { icon: icon, style: Object.assign({ fontSize: iconSize || 14 }, iconStyle) }) : icon)),
        children,
        endIcon && (React.createElement(Box, { sx: { display: 'flex', justifyContent: 'center', marginLeft: '4px' } }, typeof endIcon === 'string' ? React.createElement(RakutenIcon, { icon: endIcon, style: Object.assign({ fontSize: iconSize || 14 }, iconStyle) }) : endIcon))));
};
